import { debugToggled, targetTilesCountSet } from 'features/dev-mode/devModeSlice';
import { store } from 'store/store';
import { VirtualBackgroundManager } from 'utils/webrtc/virtual-background/VirtualBackgroundManager';

export class DevMode {
  debugEnabled: boolean = false;

  constructor() {
    window.addEventListener('keydown', (event) => {
      if (event.altKey && event.shiftKey && event.code === 'KeyD') {
        this.toggleDebug();
      }
    });
  }

  private toggleDebug = () => {
    this.debugEnabled = !this.debugEnabled;
    store.dispatch(debugToggled());
    VirtualBackgroundManager.setShowFps(this.debugEnabled);
  };

  setTargetTiles = (count: number) => {
    store.dispatch(targetTilesCountSet(count));
  };
}
